
<div class="content-container">

  <div class="outer-container">


    <div [ngClass]="controller.getClassObject(page, ['page'])">



      <div class="text">

        @if (!isIntro) {
          <div class="page-counter"> {{displayedPage}} / {{pageCount}} </div>
        }

        @for (element of page.elements; track element) {
          @if (element.type == 'br') {
            <br/>
          }
          @if (element.type == 'p') {
            <p [ngClass]="controller.getClassObject(element,[])" [innerHTML]="element.value"></p>
          }
          @if (element.type == 'header') {
            <h1 id="question-text" [ngClass]="controller.getClassObject(element,[])" [innerHTML]="element.value"></h1>
          }
        }
      </div>

      @if (isIntro) {
        <div class="image">
          @for (element of page.elements; track element) {
            @if (element.type == 'reflection-image') {
              <div class="image" style="background: url('../../../assets/img/reflection.png');"></div>
            }
          }
        </div>
      }

      <div class="question-area">
        @for (element of page.elements; track element) {
          @if (element.type == 'textarea') {
            <textarea data-testid="reflection-text" aria-labelledby="question-text" (input)="onType($event)" #textarea [placeholder]="element.properties && element.properties.placeholder ? element.properties.placeholder: 'Please enter your thoughts to continue' ">{{answer}}</textarea>
          }
        }
      </div>

    </div>

  </div>

  <div [ngClass]="getButtonsClassObject()">
    @if (emailReflections) {
      <button id='gotoContentLibrary' (click)="onNext()" class="btn btn-outline-primary btn-outline next" autocus>GO TO CONTENT LIBRARY</button>
    }

    @if (haveStart) {
      <button id='start' (click)="onNext()" class="btn btn-outline-primary btn-outline next" autocus>Start</button>
    }
    @if (haveBack) {
      <button id='back' (click)="onBack()" class="btn btn-outline-primary btn-outline next" autofocus>Back</button>
    }
    @if (haveNext) {
      <button id='next' (click)="onNext()" class="btn btn-outline-primary btn-outline next" autofocus>Next</button>
    }
  </div>


</div>

@if (!controller.isLibrary()) {
  <app-progress-bar [progressValue]=controller.getProgress()></app-progress-bar>
}
